import './index.css'
// Antes de tudo: nenhuma validação do Zod pode rodar com o JIT ligado (CSP sem 'unsafe-eval').
import './lib/zod-jitless'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'

import { appConfig } from './app/config'
import { Providers } from './app/providers'
import { createAppRouter } from './app/router'
import { listenForInstallPrompt } from './features/shell/pwa'
import { installClientErrorReporting } from './lib/client-errors'
import { startSessionSync } from './lib/session-sync'

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root ausente em index.html')

document.title = appConfig.appName
startSessionSync()
installClientErrorReporting()
// O pedido de instalação do app pode chegar antes do login (sprint-14-spec §4).
listenForInstallPrompt()

const router = createAppRouter()

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
